module.exports = __webpack_public_path__ + "static/media/joms.e2d4dec2.png";